import { useLocation, Link } from 'react-router-dom'
import { useState } from 'react'
import { Mail } from 'lucide-react'
import toast from 'react-hot-toast'
import { api } from '@/services/api'

export default function CheckEmailPage() {
  const location = useLocation()
  const email = (location.state as { email?: string } | null)?.email
  const [sending, setSending] = useState(false)

  const resend = async () => {
    if (!email) {
      toast.error('Enter your email on the login page to resend a verification link.')
      return
    }
    setSending(true)
    try {
      await api.post('/auth/resend-verification', { email })
      toast.success('If that account is unverified, we sent a new link.')
    } catch {
      toast.error('Could not resend just now. Try again in a minute.')
    } finally {
      setSending(false)
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4">
      <div className="max-w-md w-full bg-white shadow rounded-lg p-8 text-center">
        <div className="mx-auto h-12 w-12 rounded-full bg-primary-100 flex items-center justify-center mb-4">
          <Mail className="h-6 w-6 text-primary-600" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900">Check your email</h1>
        <p className="mt-3 text-sm text-gray-600">
          We sent a verification link{email ? ` to ${email}` : ''}. Confirm it to start your 30-day free trial.
          We will not charge your card until the trial ends.
        </p>
        <button
          onClick={resend}
          disabled={sending}
          className="mt-6 w-full py-2 px-4 rounded-md text-sm font-medium text-white bg-primary-600 hover:bg-primary-700 disabled:opacity-50"
        >
          {sending ? 'Sending…' : 'Resend verification email'}
        </button>
        <p className="mt-4 text-sm text-gray-500">
          Already verified?{' '}
          <Link to="/login" className="text-primary-600 font-medium">
            Sign in
          </Link>
        </p>
      </div>
    </div>
  )
}
